import {AnimationLogoEventRequestParams} from "./animation-logo-event-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../../core/app/consts";

export class AnimationLogoCardEventRequestParams extends AnimationLogoEventRequestParams {
  id: Number;
  rotate: Number;

  constructor(id: Number,isHomeCompetitor: Boolean) {
    super({resourceName: 'website/animations'});

    this.id = id;
    this._width = 32;
    this.ratio = 3;
    this.rotate = isHomeCompetitor ? -38 : 0;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.AUTO;
  }

  get angle() {
    return this.rotate;
  }

  toString(): String {
    return super.toString();
  }
}